<!-- Checkbox with label on the left and tickbox on the right
To be used as a part of a fieldset
Used in language select and withdrawal reasons modals -->
<template>
   <div class="checkbox-block mb-1 flex min-h-12 w-full cursor-pointer items-center rounded-md last-of-type:mb-0">
      <input
         :id="id"
         data-cy="checkbox-input"
         :name="group"
         type="checkbox"
         :checked="props.value"
         class="absolute right-0 z-1 mr-6 size-5 cursor-pointer"
         @change="(event: Event) => emit('update:value', (event.target as HTMLInputElement).checked)"
      />
      <label
         :for="id"
         class="checkbox-block-label flex min-h-12 w-full cursor-pointer items-center rounded-md text-black"
      >
         <span class="py-2 pl-4 pr-16">{{ label }}</span>
      </label>
   </div>
</template>

<script setup lang="ts">
interface Props {
   id: string;
   label: string;
   group: string;
   value: boolean;
}
const props = defineProps<Props>();

const emit = defineEmits(["update:value"]);
</script>

<style lang="scss" scoped>
@use "@/assets/mixins.scss" as mixins;

.checkbox-block input {
   accent-color: var(--colour-brand-default);
}

// remove outline from input and add it to the label instead
.checkbox-block input:focus-visible {
   outline: none !important;
   box-shadow: none;

   & + label {
      @include mixins.focus-outline;
   }
}

.checkbox-block input:checked {
   accent-color: var(--colour-brand-default);
}
.checkbox-block input:checked + .checkbox-block-label {
   background: var(--grey-10);
   color: var(--black);
}
</style>
